const timeoutCodes = new Set(['ECONNABORTED', 'ETIMEDOUT'])
const mongoTimeoutCodes = new Set([50, 262])
const timeoutMessage =
  /timeout|timed out|deadline exceeded|maxtimems|exceededtimelimit|exceeded (?:the )?time limit|time limit exceeded|execution.*time limit|server selection.*timeout|socket.*timeout/

export const getDimorderStatementErrorKey = (error) => {
  const code = typeof error?.code === 'string' ? error.code.toUpperCase() : ''
  const data = error?.response?.data ?? {}
  const errorData = typeof data.error === 'object' && data.error !== null ? data.error : {}
  const messages = [
    error?.message,
    typeof data.error === 'string' ? data.error : undefined,
    data.message,
    errorData.message,
    data.codeName,
    errorData.codeName,
  ]
    .filter((value) => typeof value === 'string')
    .join(' ')
    .toLowerCase()
  const mongoCode = Number(data.code ?? errorData.code)

  if (
    timeoutCodes.has(code) ||
    [408, 504].includes(error?.response?.status) ||
    mongoTimeoutCodes.has(mongoCode) ||
    timeoutMessage.test(messages)
  ) {
    return 'queryTimeout'
  }

  return 'exportError'
}
